import { useContext } from 'react';
import { makeStyles } from 'tss-react/mui';
import { Toolbar } from '@devexpress/dx-react-scheduler-material-ui';
import { SchedulerContext } from '../../SchedulerContext';
import EDTypography from '../../../../../../../../BaseComponents/Typography/EDTypography';
import EDSwitch from '../../../../../../../../BaseComponents/Switch/EDSwitch';
import ListFilteringComponent from '../../../../../../_Common/Components/ListFilteringComponent/ListFilteringComponent';
import { SchedulerFilterContext } from '../SchedulerFilterContext';
import {
  useIsExtraSmallScreen,
  useIsSmallScreen,
} from '../../../../../../../../Hooks/useFullscreenView';
import EDBox from '../../../../../../../../BaseComponents/EDBox/EDBox';
import { ViewDbSettingsContext } from '../ViewDbSettingsContext';
import EDIcon from '../../../../../../../../BaseComponents/Icon/EDIcon';

const useStyles = makeStyles()(() => ({
  flexibleSpace: {
    width: '100%',
    marginLeft: '0 !important',
    flex: 'auto !important',
    '& > :first-of-type': {
      '& > :first-of-type': {
        '& > :first-of-type': {
          '& > :first-of-type': {
            '& > :first-of-type': {
              minWidth: '350px !important',
            },
          },
        },
      },
    },
  },
  filterContainer: {
    '& > :first-of-type': {
      '& > :first-of-type': {
        '& > :first-of-type': {
          '& > :first-of-type': {
            '& > :first-of-type': {
              minWidth: '0 !important',
            },
          },
        },
      },
    },
  },
}));

export const ToolbarFlexibleSpaceComponent = (
  props: Toolbar.FlexibleSpaceProps
) => {
  const schedulerContext = useContext(SchedulerContext);
  const overView = schedulerContext.overView;
  const onOverViewChange = schedulerContext.onOverViewChange;
  const schedulerFilterContext = useContext(SchedulerFilterContext);
  const viewDbSettingsContext = useContext(ViewDbSettingsContext);
  const isExtraSmallScreen = useIsExtraSmallScreen();
  const isSmallScreen = useIsSmallScreen();
  const showOutlookBookings = schedulerContext.showOutlookBookings;
  const setShowOutlookBookings = schedulerContext.setShowOutlookBookings;

  const noResources =
    schedulerContext.resources == null ||
    schedulerContext.resources.length === 0;
  const { classes, cx } = useStyles();

  return (
    <Toolbar.FlexibleSpace
      className={cx(classes.flexibleSpace, {
        [classes.filterContainer]: isSmallScreen,
      })}
      {...props}
    >
      <EDBox
        sx={{
          display: 'flex',
          width: '100%',
        }}
      >
        <ListFilteringComponent
          onSearchTextChanged={schedulerFilterContext.onSearchTextChanged}
          searchText={schedulerFilterContext.searchText ?? ''}
          sortedData={schedulerFilterContext.sortedData}
          filterAttributes={schedulerFilterContext.filterAttributes}
          listlength={schedulerFilterContext.listlength}
          sortedLength={schedulerFilterContext.sortedLength}
          visningsTyp={schedulerFilterContext.visningsTyp}
          filterAttributesPlacholder={`Filtrera på t.ex. ${schedulerFilterContext?.filterAttributes
            ?.filter(x => x.label !== '')
            .map(attr => attr.label)
            .join(', ')
            .replace(/, (?!.*, )/, ' eller ')}`}
          width={isExtraSmallScreen || isSmallScreen ? '100%' : 350}
        />
        {!isSmallScreen && (
          <EDBox
            sx={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <EDIcon iconType="outlook" />
            <EDSwitch
              title={
                showOutlookBookings
                  ? 'Dölj Outlook-bokningar'
                  : 'Visa Outlook-bokningar'
              }
              checked={showOutlookBookings}
              onChange={(_, checked) => {
                setShowOutlookBookings && setShowOutlookBookings(checked);
              }}
            />
          </EDBox>
        )}

        {viewDbSettingsContext.currentView === 'Day' && (
          <EDBox
            sx={{
              display: isSmallScreen ? 'none' : 'flex',
              alignItems: 'center',
            }}
          >
            <EDTypography
              bold
              color="textSecondary"
              fontSize={isExtraSmallScreen || isSmallScreen ? 10 : 13}
            >
              Översikt
            </EDTypography>
            <EDSwitch
              title={
                noResources
                  ? 'Kan inte aktivera översikt eftersom inga resurser är valda'
                  : 'Skapa en översikt genom att jämföra valda resurser i kalendervyn'
              }
              checked={overView}
              onChange={(_, checked) => {
                onOverViewChange && onOverViewChange(checked);
              }}
              disabled={noResources}
            />
          </EDBox>
        )}
      </EDBox>
    </Toolbar.FlexibleSpace>
  );
};
